import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Itens({ commit, state }, params) {
    let ano = params.ano ? params.ano : state.ano;
    params.ano = params.ano ? params.ano.value : state.ano.value;
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("orcamento/fornecedor", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        commit("setAno", ano);
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async Store({ commit, state }) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "orcamento/fornecedor",
      headers,
      data: state.orcamento.itens
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        commit(
          "setAno",
          state.selects.ano.find(a => a.value == resp.data.itens[0].ano)
        );
        return "ok";
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Update({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "put",
      url: "orcamento/fornecedor/" + params.id,
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Delete({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .delete("orcamento/fornecedor/" + params.id, {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Orcar({ commit, state }, params) {
    commit("setOrcamentos", []);
    params.mes.forEach(m => {
      commit("setOrcamento", {
        fornecedor: state.selects.fornecedores.find(
          c => c.value == params.fornecedor_id
        ),
        comprador: state.selects.compradores.find(
          c => c.value == params.comprador_id
        ),
        ano: params.ano,
        itens: {
          fornecedor_id: params.fornecedor_id,
          comprador_id: params.comprador_id,
          mes: m.value ? m.value : m,
          ano: params.ano,
          total_previsto_compra: params.total_previsto_compra
        }
      });
    });
    return "ok";
  },
  async Orcamentos({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    params.orcamentos = true;
    commit("setOrcamentos", []);
    return await api
      .get("orcamento/fornecedor", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        params.itens = resp.data.itens;
        commit("setOrcamentos", params);
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Fornecedores({ commit }) {
    const headers = Helpers.iniciarRequisicao();
    const params = { fornecedores: true };
    return await api
      .get("orcamento/fornecedor", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setFornecedores", resp.data.itens);
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Compradores({ commit }) {
    const headers = Helpers.iniciarRequisicao();
    const params = { compradores: true };
    return await api
      .get("orcamento/fornecedor", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setCompradores", resp.data.itens);
      })
      .catch(() => {
        // Helpers.logout();
      });
  }
};
